import { css } from "../../../../styled-system/css";

export const styles = {
  divItem: (isOpen: boolean) =>
    css({
      width: "100%",
      backgroundColor: isOpen ? "white" : "backgroundGrey",
      borderBottom: "1px solid",
      borderBottomColor: "outlineGrey",
      transition: "background-color 0.25s ease",
      _lastOfType: {
        borderBottom: "none",
      },
    }),

  divItemHead: () =>
    css({
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    }),

  divIconAndTitle: () =>
    css({
      display: "flex",
      paddingY: "baseUnit.mobile2",
      paddingLeft: "baseUnit.mobile2",
    }),

  icon: () =>
    css({
      width: "36px",
      height: "36px",
    }),

  spanTitle: () =>
    css({
      color: "linkBlue",
      fontWeight: 600,
      fontSize: "body.horse",
      lineHeight: "body.horse",
      padding: "5px 15px",
    }),

  divHeadRight: () =>
    css({
      display: "flex",
    }),

  openCloseArrow: () =>
    css({
      boxSizing: "content-box",
      width: "baseUnit.mobile2",
      height: "baseUnit.mobile2",
      margin: "baseUnit.mobile3",
      background: "none",
      border: "none",
      cursor: "pointer",
    }),

  imgOpenCloseArrow: (isOpen: boolean) =>
    css({
      "& svg": {
        width: "16px",
        height: "20px",
        transform: isOpen ? "rotate(180deg)" : null,
      },
    }),

  divItemBody: (isOpen: boolean) =>
    css({
      width: "100%",
      height: "auto",
      maxHeight: isOpen ? 10000 : 0,
      paddingX: "baseUnit.mobile2",
      overflow: "hidden",
      transition: "max-height 0.25s ease",
      color: "headlineGrey",
      desktop: {
        paddingX: "baseUnit.mobile3",
      },
    }),

  divItemBodyInner: () =>
    css({
      width: "100%",
      paddingBottom: "baseUnit.mobile3",
      fontSize: "body.horse",
      lineHeight: "body.horse",
      "& img": {
        maxWidth: "100%",
      },
    }),

  link: () =>
    css({
      width: "100%",
      fontWeight: "bold",
      textTransform: "uppercase",
      display: "inline-block",
      marginBottom: "baseUnit.mobile3",
      fontSize: "body.cat",
      desktop: {
        fontSize: "body.horse",
        lineHeight: "body.horse",
      },
    }),
};
